"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHierarchyFilters = useHierarchyFilters;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
const app_1 = require("app");
const SearchResultTranslationService_1 = require("../../services/SearchResultTranslationService");
const SearchResultFilterService_1 = require("../../services/SearchResultFilterService");
const HIERARCHY_DUMMY_KEY = 'hierarchyDummyKey';
function useHierarchyFilters(selectedTab, dictionary) {
    var _a, _b, _c;
    const { uiState } = (0, react_instantsearch_1.useInstantSearch)();
    const selectedSegmentValue = ((_b = (_a = uiState[selectedTab.indexName]) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.segments) || '';
    const hierarchyFiltersAttributes = ((_c = selectedTab.hierarchicalAttributes) === null || _c === void 0 ? void 0 : _c[selectedSegmentValue]) || [];
    const attributeKeys = React.useMemo(() => (hierarchyFiltersAttributes === null || hierarchyFiltersAttributes === void 0 ? void 0 : hierarchyFiltersAttributes.map(attr => attr.key)) || [], [hierarchyFiltersAttributes]);
    const hasAttributes = attributeKeys.length > 0;
    const { items, refine } = (0, react_instantsearch_1.useHierarchicalMenu)({
        attributes: hasAttributes ? attributeKeys : [HIERARCHY_DUMMY_KEY],
        sortBy: ['name:asc'],
        limit: 1000,
    });
    const { refine: clearRefinements } = (0, react_instantsearch_1.useClearRefinements)({
        includedAttributes: hasAttributes ? attributeKeys : [HIERARCHY_DUMMY_KEY],
    });
    const nestedFilterLevels = React.useMemo(() => (hasAttributes ? SearchResultFilterService_1.searchResultFilterService.transformHierarchyToFilters(items) : []), [items, hasAttributes]);
    if (!hasAttributes) {
        return [];
    }
    return hierarchyFiltersAttributes.map((attribute, index) => {
        var _a;
        return ({
            key: attribute.key,
            label: dictionary[attribute.label] || attribute.label,
            mobileLabel: (_a = (dictionary[attribute.mobileLabel] || attribute.mobileLabel)) !== null && _a !== void 0 ? _a : undefined,
            items: SearchResultTranslationService_1.searchResultTranslationService.provideStructureAndTranslatedLabel(nestedFilterLevels[index] || [], dictionary),
            type: app_1.FilterTypeEnum.HierarchySelect,
            refine,
            clearRefinements,
            isHidden: attribute.isHidden,
            guiType: attribute.guiType,
            gtmKey: (attribute === null || attribute === void 0 ? void 0 : attribute.gtmKey) || '',
        });
    });
}
